import { usePaginatedMasterData } from './usePaginatedMasterData';
import { getWorkPolicies } from '../services/workPolicyService';
import type {
  WorkPolicyListFilters,
  WorkPolicyListItem,
} from '../types/workPolicy';
import { activeConfigurationFilters } from '../utils/configurationFilters';

const EMPTY_FILTERS: WorkPolicyListFilters = activeConfigurationFilters();

export function useWorkPolicies() {
  return usePaginatedMasterData<WorkPolicyListItem, WorkPolicyListFilters>({
    getId: item => item.workPolicyId,
    initialFilters: EMPTY_FILTERS,
    errorMessage: 'Unable to load work policies.',
    loadPage: async ({ page, pageSize, search, filters }) =>
      getWorkPolicies({
        page,
        pageSize,
        filters: {
          ...filters,
          search: search || undefined,
        },
      }),
  });
}
